import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import logo from '../../assets/Project_Images/App_logo.png'
import { toast, ToastContainer } from 'react-toastify'
import { ApiGetResend2FA, ApiUsersLogin } from '../../apiService/Core/Apicall.tsx'


function OtpVerification() {
    const location = useLocation()

    const { username, password, tempToken } = location.state || {}
    const navigate = useNavigate()
    const [error, setError] = useState('')
    const [otp, setOtp] = useState<string[]>(Array(6).fill(''))
    const [showerror, setShowerror] = useState(false)

    const inputRefs = useRef<(HTMLInputElement | null)[]>([])
    const [token, setToken] = useState()
    const [userName, setUserName] = useState()
    const [Password, setPassword] = useState()
    const [resendTimer, setResendTimer] = useState(120)


    useEffect(() => {
        if (resendTimer <= 0) return

        const timer = setInterval(() => {
            setResendTimer(prev => {
                if (prev <= 1) {
                    clearInterval(timer)
                    return 0
                }

                return prev - 1
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [resendTimer])


    const formatTimer = (seconds: number) => {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60

        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
    }

    useEffect(() => {
        if (!username || !password || !tempToken) {
            const userData = JSON.parse(localStorage.getItem("userData") || "{}");
            if (!userData.userId) {
                navigate('/login', { replace: true })
                return
            }
            else {
                navigate('/dashboard/dashboard', { replace: true })
                return
            }
        }
        setToken(tempToken)
        setPassword(password)
        setUserName(username)
        navigate(location.pathname, {
            replace: true,
            state: null
        })

    }, [])
    const handleOtpChange = (value: string, index: number) => {
        // Only allow numbers
        if (!/^\d*$/.test(value)) return

        const newOtp = [...otp]
        newOtp[index] = value.slice(-1)

        setOtp(newOtp)

        // Move to next input
        if (value && index < 5) {
            inputRefs.current[index + 1]?.focus()
        }
    }

    const handleKeyDown = (
        e: React.KeyboardEvent<HTMLInputElement>,
        index: number
    ) => {
        // Move to previous input on backspace
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus()
        }
    }

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault()

        const pastedOtp = e.clipboardData
            .getData('text')
            .replace(/\D/g, '')
            .slice(0, 6)

        if (!pastedOtp) return

        const newOtp = Array(6).fill('')

        pastedOtp.split('').forEach((digit, index) => {
            newOtp[index] = digit
        })

        setOtp(newOtp)

        inputRefs.current[
            Math.min(pastedOtp.length, 5)
        ]?.focus()
    }

    const handleVerify = async (e: React.FormEvent) => {
        e.preventDefault()

        setShowerror(true)
        const otpValue = otp.join('')

        if (otpValue.length !== 6) {
            setError('Please enter the 6-digit OTP')
            return
        }

        const Apidata = {
            emailId: userName,
            password: Password,
            tempToken: token,
            otp: otpValue
        }
        try {
            const response: any = await ApiUsersLogin(Apidata);
            if (response.status && response.userDetails.role.roleName === 'shopper') {
                const userData = {
                    'userId': response.userDetails.userId,
                    'shopperAgreementFileUrl': response.userDetails.shopperAgreementFileUrl,
                    'isCompletedForm1': response.userDetails.isShopperStep1DocumentSubmitted,
                    'isCompletedAllForm': response.userDetails.isShopperAllDocumentSubmitted,
                    'userStatus': response.userDetails.userStatus.userStatus,
                    'isLatestAgreementSigned': response.userDetails.isLatestAgreementSigned,
                    'isMigratedShopper': response?.otherDetails?.isMigratedShopper,
                    'isMigratedShopperUpdateDetails': response?.otherDetails?.isMigratedShopperUpdateDetails,

                }
                localStorage.setItem('userData', JSON.stringify(response.userDetails));
                localStorage.setItem('userOthreData', JSON.stringify(response.otherDetails));
                localStorage.setItem('token', response?.token || 0);
                localStorage.setItem('isTransport', response.otherDetails?.isShopperCanWorkForTransport);
                localStorage.setItem('ActiveTask', 'dashboard');

                if (userData.userStatus === 'delete') {
                    toast.error("Account not found")
                    localStorage.clear()
                    navigate('/login')
                }
                else if (response.userDetails.isAirTasker) {
                    navigate('/dashboard/dashboard')
                }
                else if (userData.isCompletedForm1 && (userData.isLatestAgreementSigned === false)) {
                    localStorage.setItem('i-x-s', response.otherDetails.isMigratedShopper);
                    localStorage.setItem('i-x-s-u', response.otherDetails.isMigratedShopperUpdateDetails);
                    navigate('/agreement')
                }
                else if (userData?.isMigratedShopper && userData.isMigratedShopperUpdateDetails === false) {
                    localStorage.setItem('i-x-s', response.otherDetails.isMigratedShopper);
                    localStorage.setItem('i-x-s-u', response.otherDetails.isMigratedShopperUpdateDetails);
                    navigate('/dashboard/myprofile')
                }
                else if (userData.isCompletedForm1) {
                    // if()
                    if (userData.isCompletedAllForm && userData.userStatus === 'active') {
                        navigate('/dashboard/dashboard')
                        // navigate('/terms')
                    }
                    else if (userData.userStatus === 'approve') {
                        navigate('/applicationform2')
                    }
                    else {
                        navigate('/applicationform')
                    }
                }
                else {
                    navigate('/applicationform')
                }
            }
            else {
                toast.error('Invalid Access')
            }
        }
        catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
            // alert(message)

        }
    }

    const ResendOTP = async () => {
        if (resendTimer > 0) return
        try {
            const loginData = {
               tempToken: token,
            }
            const response: any = await ApiGetResend2FA(loginData)
            if (response?.status) {
                // setToken(response?.tempToken)
                setResendTimer(120)
                toast.success(response?.message)
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went worng")
            console.error('Error during API call:', error)
        }
    }

    return (
        // <Box
        //     className='p-50-120 d-flex flex-column'
        //     height={{ xs: '81vh', sm: '100vh' }}
        // >

        //     {/* Logo */}
        //     <Box
        //         component='img'
        //         className='col-md-4 col-6 mb-md-4 mb-5'
        //         src={logo}
        //         alt='Mystery Management'
        //     />

        //     <Box
        //         className='flex-grow-1'
        //         position='relative'
        //     >

        //         {/* Heading */}
        //         <Typography className='text-main fs-3 fw-bold'>
        //             Verify OTP
        //         </Typography>

        //         <Typography className='fs-18'>
        //             Enter the 6-digit OTP sent to your email.
        //         </Typography>

        //         <Box className='mt-5 mt-md-0 mb-0 pb-0'>

        //             <form onSubmit={handleVerify}>

        //                 <FormControl className='col-12'>

        //                     {/* OTP Boxes */}
        //                     <Box
        //                         className='d-flex justify-content-center'
        //                         gap={{ xs: 1, sm: 2 }}
        //                         mt={2}
        //                         mb={1}
        //                     >
        //                         {otp.map((digit, index) => (
        //                             <TextField
        //                                 key={index}
        //                                 inputRef={(element) => {
        //                                     inputRefs.current[index] = element
        //                                 }}
        //                                 value={digit}
        //                                 onChange={(e) =>
        //                                     handleOtpChange(
        //                                         e.target.value,
        //                                         index
        //                                     )
        //                                 }
        //                                 onKeyDown={(e:any) =>
        //                                     handleKeyDown(e, index)
        //                                 }
        //                                 onPaste={handlePaste}
        //                                 inputProps={{
        //                                     maxLength: 1,
        //                                     inputMode: 'numeric',

        //                                     autoComplete:
        //                                         index === 0
        //                                             ? 'one-time-code'
        //                                             : 'off',
        //                                 }}
        //                                 sx={{
        //                                     width: {
        //                                         xs: '44px',
        //                                         sm: '55px',
        //                                     },

        //                                     '& input': {
        //                                         textAlign: 'center !important',
        //                                         fontSize: '22px',
        //                                         fontWeight: 600,
        //                                         padding: "12px 12px"
        //                                         // padding: '12px 0',
        //                                     },
        //                                 }}
        //                             />
        //                         ))}
        //                     </Box>

        //                     {/* {showerror && otp.join('').length !== 6 && (
        //                         <Typography className='error'>
        //                             Please enter a valid 6-digit OTP
        //                         </Typography>
        //                     )} */}
        //                     {error && (
        //                             <div
        //                                 className='text-danger  text-center'
        //                                 style={{ marginTop: '8px' }}
        //                             >
        //                                 {error}
        //                             </div>
        //                         )}

        //                 </FormControl>

        //                 {/* Resend OTP */}
        //                 <Box className='text-end my-2'>
        //                     <Button
        //                         type='button'
        //                         onClick={ResendOTP}
        //                         className='custom-text'
        //                         sx={{
        //                             textTransform: 'none',
        //                             padding: 0,
        //                             minWidth: 'auto',
        //                         }}
        //                     >
        //                         Resend OTP
        //                     </Button>
        //                 </Box>

        //                 {/* Verify Button */}
        //                 <Button
        //                     type='submit'
        //                     fullWidth
        //                     className='button-primary mt-5'
        //                 >
        //                     Verify OTP
        //                 </Button>

        //             </form>

        //         </Box>

        //     </Box>
        // </Box>
        <Box className='p-50-120 d-flex flex-column' height={{ xs: "80vh", sm: '100vh' }}>
            <ToastContainer/>
            <Box component='img' className='col-md-4 col-6 mb-md-5 mb-3' src={logo} alt="" />
            <Box className='flex-grow-1 mt-5' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>Verify OTP</Typography>
                <Typography className='fs-18 '>Enter the 6-digit OTP sent to your email.</Typography>
                <Box>
                    <form onSubmit={handleVerify}>
                        <FormControl className='col-12 mt-5'>
                            <InputLabel>
                                <span>OTP{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </InputLabel>
                            <Box display="flex" gap={1} justifyContent="center">
                                {otp.map((digit, index) => (
                                    <Box key={index} display="flex" flexDirection="column" alignItems="center">
                                        <TextField
                                            id={`otp-${index}`}
                                            value={digit}
                                            onChange={(e) =>
                                                handleOtpChange(
                                                    e.target.value,
                                                    index
                                                )
                                            }
                                            onKeyDown={(e: any) =>
                                                handleKeyDown(e, index)
                                            }
                                            onPaste={handlePaste}
                                            inputRef={(element) => {
                                                inputRefs.current[index] = element
                                            }}
                                            variant="outlined"
                                            className='otp'
                                            inputProps={{
                                                maxLength: 1,
                                                style: { textAlign: 'center', fontSize: '1.5rem', padding: '14px' }
                                            }}

                                        />

                                    </Box>
                                ))}
                            </Box>
                        </FormControl>
                        <Box className='d-flex align-items-center justify-content-between'>
                            {error && (
                                <div
                                    className='text-danger  text-center'
                                    style={{ marginTop: '8px', fontSize: '14px' }}
                                >
                                    {error}
                                </div>
                            )}
                            {resendTimer > 0
                                ?
                                <Typography variant='subtitle2' className='mt-3'>Resend OTP in {formatTimer(resendTimer)}</Typography> :
                                <Typography sx={{ color: '#ADB792', textDecoration: 'underline', cursor: 'pointer' }} className='text-end d-block mt-2' onClick={ResendOTP}>Resend OTP?</Typography>
                            }
                        </Box>
                        <Button
                            type='submit'
                            fullWidth
                            className='button-primary mt-5'
                        >
                            Verify OTP
                        </Button>
                    </form>

                </Box>
            </Box>
        </Box>
    )
}

export default OtpVerification